import WidgetsMgr from 'widgets/widgetsMgr';
import QuickShopTileMixin from './product/QuickShopTileMixin';
import TileImageCarousel from 'core/product/TileImageCarousel';

WidgetsMgr.addWidgetsList('global.core', () => [
    ['productTile', QuickShopTileMixin, 'productTile'],
    ['tileImageCarousel', TileImageCarousel, 'carousel']
]);

const hasContext = (context: string) => window.contexts.includes(context);

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp') && hasContext('gallery'),
    load: () =>
        import(
            /* webpackChunkName: 'product.gallery.inline-zoom' */
            'core/product/ProductImagesGalleryInlineZoom'
        )
            .then((d) => d.default)
            .then((ProductImagesGalleryInlineZoom) => {
                return {
                    listId: 'product.gallery.inline-zoom',
                    widgetsDefinition: () => [
                        ['productImagesGallery', ProductImagesGalleryInlineZoom, 'productImagesGallery']
                    ]
                };
            })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('quickBuy'),
    load: () => import(/* webpackChunkName: 'product.quickshop' */ './product/QuickShopBuyMixin').then(d => {
        const QuickShopBuyMixin = d.default;

        return {
            listId: 'product.quickshop',
            widgetsDefinition: () => [
                ['quickBuy', QuickShopBuyMixin, 'quickBuy']
            ]
        };
    })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('cart'),
    load: () => import(/* webpackChunkName: 'cart.core' */ './cart/CartMgrQuickShopMixin').then(d => {
        const CartMgrQuickShopMixin = d.default;

        return {
            listId: 'cart.core',
            widgetsDefinition: () => [
                ['cartMgr', CartMgrQuickShopMixin, 'cartMgr']
            ]
        };
    })
});
